import { Trophy, Medal, Award } from 'lucide-react'

interface LeaderboardEntry {
  rank: number
  id: number
  name: string
  specialty: string | null
  total_points: number
  level: number
  is_current_user: boolean
}

interface LeaderboardTableProps {
  entries: LeaderboardEntry[]
}

export function LeaderboardTable({ entries }: LeaderboardTableProps) {
  if (entries.length === 0) {
    return (
      <p className="text-gray-500 text-center py-4">
        Aucun utilisateur dans le classement.
      </p>
    )
  }

  return (
    <div className="space-y-2">
      {entries.slice(0, 10).map((entry) => (
        <div
          key={entry.id}
          className={`flex items-center gap-3 p-2 rounded-lg ${
            entry.is_current_user
              ? 'bg-tessan-cream border border-tessan-primary'
              : 'hover:bg-gray-50'
          }`}
        >
          <div className="w-8 flex justify-center">
            {entry.rank === 1 ? (
              <Trophy className="w-5 h-5 text-yellow-500" />
            ) : entry.rank === 2 ? (
              <Medal className="w-5 h-5 text-gray-400" />
            ) : entry.rank === 3 ? (
              <Award className="w-5 h-5 text-orange-400" />
            ) : (
              <span className="text-sm font-medium text-gray-500">
                {entry.rank}
              </span>
            )}
          </div>

          <div className="w-8 h-8 rounded-full bg-tessan-primary text-white flex items-center justify-center text-sm font-medium">
            {entry.name.charAt(0).toUpperCase()}
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {entry.name}
              {entry.is_current_user && (
                <span className="ml-1 text-tessan-primary">(vous)</span>
              )}
            </p>
            {entry.specialty && <p className="text-xs text-gray-500 truncate">{entry.specialty}</p>}
          </div>

          <div className="text-right">
            <p className="text-sm font-semibold text-tessan-primary">
              {entry.total_points.toLocaleString('fr-FR')}
            </p>
            <p className="text-xs text-gray-500">Niv. {entry.level}</p>
          </div>
        </div>
      ))}
    </div>
  )
}
